import { render } from "./FlowResourceCard.vue?vue&type=template&id=23ae0df8&scoped=true"
import script from "./FlowResourceCard.vue?vue&type=script&lang=js"
export * from "./FlowResourceCard.vue?vue&type=script&lang=js"

import "./FlowResourceCard.vue?vue&type=style&index=0&id=23ae0df8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ae0df8"]])

export default __exports__